import { render, staticRenderFns } from "./UpdateStageDateDialog.vue?vue&type=template&id=506d0cf1"
import script from "./UpdateStageDateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateStageDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports